<section class="notification-table">
    <h3 class="section-heading">Email/Text Notification</h3>
    @if (unavailable) {
        <p class="empty-message">Notification history is temporarily unavailable. Please try again later.</p>
    } @else if (notifications.length === 0) {
        <p class="empty-message">No notifications</p>
    } @else {
        <div class="table-container">
            <table class="data-table">
                <thead>
                    <tr>
                        <th class="table-header">Notification type</th>
                        <th class="table-header">Sent Date and Time</th>
                        <th class="table-header">Recipient</th>
                        <th class="table-header">Status</th>
                        <th class="table-header">Reference ID</th>
                    </tr>
                </thead>
                <tbody>
                    @for (notification of sortedNotifications; track $index) {
                        <tr class="table-row">
                            <td class="table-cell">{{ notification.notificationType }}</td>
                            <td class="table-cell">{{ notification.sentDateTime | date:'MM/dd/yyyy hh:mm:ss a' }}</td>
                            <td class="table-cell">{{ notification.recipient }}</td>
                            <td class="table-cell">
                                <ach-notification-status-badge [status]="notification.status" />
                            </td>
                            <td class="table-cell">
                                @if (notification.referenceId) {
                                    <a class="reference-id"
                                       [href]="notification.referenceId"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        <svg class="reference-id__icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                        View
                                    </a>
                                } @else {
                                    <span class="table-cell--empty">—</span>
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</section>
